module.exports = __webpack_public_path__ + "static/media/fast-icon.1e162f7d.svg";